export { ProductButtons } from "./ProductButtons";
export { ProductImage } from "./ProductImage";
export { ProductTitle } from "./ProductTitle";


import { ProductCard as  ProductCardHOC} from "./ProductCard";
import { ProductButtons } from "./ProductButtons";
import { ProductImage } from "./ProductImage";
import { ProductTitle } from "./ProductTitle";
import { ProductCardHOCProps } from "../interfaces/products.interface";

export const ProductCard: ProductCardHOCProps = Object.assign(ProductCardHOC,{
    Title: ProductTitle,
    Image:ProductImage,
    Buttons: ProductButtons
});

export default ProductCard;


